import { render, staticRenderFns } from "./PromotionTypeForm.vue?vue&type=template&id=98308ee4"
import script from "./PromotionTypeForm.vue?vue&type=script&lang=js"
export * from "./PromotionTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports